import _ from "lodash";

export function debounce(fn: () => void, timeout: number) {
    let timeoutId: ReturnType<typeof setTimeout> | null = null;

    function debounce() {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }

        timeoutId = setTimeout(() => {
            fn();
        }, timeout);
    }

    return debounce;
}

export function transformEmptyStringToNull(value: string | null | undefined): string | null {
    if (value === null || value === undefined) {
        return null;
    }

    const trimmedValue = _.trim(value);
    if (trimmedValue === "") {
        return null;
    }

    return trimmedValue;
}

export function printToLetter(number: number): string | undefined {
    let result = "";
    const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

    let charIndex = number % alphabet.length;
    let quotient = number / alphabet.length;
    if (charIndex - 1 === -1) {
        charIndex = alphabet.length;
        quotient--;
    }
    result = alphabet.charAt(charIndex - 1) + result;
    if (quotient >= 1) {
        return printToLetter(quotient);
    } else {
        return result;
    }
}
